import { __assign, __rest } from "tslib";
import React from 'react';
import MeasuredGrid from './MeasuredGrid';
import { adjustBreakpointHeight, DEFAULT_BREAKPOINTS } from './breakpoints';
export var StandardGrid = function (_a) {
    var _b = _a.adjustHeight, adjustHeight = _b === void 0 ? 0 : _b, _c = _a.breakpoints, breakpoints = _c === void 0 ? DEFAULT_BREAKPOINTS : _c, children = _a.children, props = __rest(_a, ["adjustHeight", "breakpoints", "children"]);
    return (React.createElement(MeasuredGrid, __assign({}, props, { breakpoints: adjustHeight
            ? adjustBreakpointHeight(breakpoints, adjustHeight)
            : breakpoints, renderElement: children })));
};
export default StandardGrid;
//# sourceMappingURL=StandardGrid.js.map